import { EmploymentType, WorkMode } from "features/User/models";
import * as yup from "yup";

// PROFILE INFO
export const FIRST_NAME_FIELD = {
  label: "First Name",
  name: "firstName",
};
export const LAST_NAME_FIELD = {
  label: "Last Name",
  name: "lastName",
};
export const PREFERRED_NAME_FIELD = {
  label: "Preferred Name",
  name: "preferredName",
};
export const PRONOUNS_FIELD = {
  name: "pronouns",
  label: "Pronouns",
};
export const TITLE_FIELD = {
  label: "Job Title",
  name: "title",
};
export const START_DATE_FIELD = {
  label: "Start Date",
  name: "startDate",
};
export const LINKEDIN_URL_FIELD = {
  label: "LinkedIn Url",
  name: "linkedinUrl",
};
export const PERSONAL_EMAIL_FIELD = {
  label: "Personal Email",
  name: "personalEmail",
  textTransform: "lowercase",
};
export const WORK_EMAIL_FIELD = {
  label: "Future Work Email (if known)",
  name: "workEmail",
  textTransform: "lowercase",
};
export const LOCATION_FIELD = {
  label: "Location",
  name: "location",
};
export const RAW_LOCATION_FIELD = {
  label: "rawLocation",
  name: "rawLocation",
};
export const GOOGLE_LOCATION_ID_FIELD = {
  label: "Google Location Id",
  name: "googleLocationId",
};
export const TIMEZONE_FIELD = {
  label: "Timezone",
  name: "timezone",
};
export const PATH_SELECT_FIELD = {
  label: "Select Paths",
  name: "pathIds",
};
export const ONBOARDING_PLAN_URL_FIELD = {
  label: "Onboarding Plan Url",
  name: "onboardingPlanUrl",
};

// SUPPORT TEAM FIELDS
export const MANAGER_FIELD = {
  label: "Manager",
  name: "managerId",
};
export const BUDDY_FIELD = {
  label: "Buddy",
  name: "buddyId",
  helperText: "Typically assigned by manager. Can add now if known",
};
export const PEOPLE_TEAM_CONTACT_FIELD = {
  label: "People Team Contact",
  name: "peopleTeamContactId",
};

// ADDITIONAL FIELDS
export const DEPARTMENT_FIELD = {
  label: "Department",
  name: "department",
};
export const COUNTRY_FIELD = {
  label: "Country",
  name: "country",
};
export const COUNTRY_CODE_FIELD = {
  label: "Country Code (e.g. +1 for US)",
  name: "phoneCountryCode",
};
export const PHONE_NUMBER_FIELD = {
  label: "Phone Number",
  name: "phoneNumber",
};
export const EMPLOYMENT_TYPE_FIELD = {
  label: "Employment Type",
  name: "employmentType",
};
export const WORK_MODE_TYPE_FIELD = {
  label: "Work Mode",
  name: "workMode",
};
export interface NewHireFormValues {
  firstName: string;
  lastName: string;
  title: string;
  personalEmail?: string;
  workEmail?: string;
  location?: string;
  timezone?: string;
  peopleTeamContactId?: string;
  managerId?: string;
  buddyId?: string;
  startDate?: Date;
  pronouns?: string;
  linkedinUrl?: string;
  department?: string;
  country?: string;
  phoneCountryCode?: string;
  phoneNumber?: string;
  employmentType?: EmploymentType;
  workMode?: WorkMode;
  pathIds?: string[];
}

export const pendingNewHireSchema = yup.object({
  firstName: yup.string().label("First Name").required(),
  lastName: yup.string().label("Last Name").required(),
  preferredName: yup.string().label("Preferred Name").notRequired(),
  title: yup.string().label("Title").required(),
  managerId: yup.string().label("Manager").required(),
  buddyId: yup.string().label("Buddy").notRequired(),
  peopleTeamContactId: yup.string().label("People Team Contact").required(),
  personalEmail: yup.string().label("Personal Email").email().lowercase()
    .required(),
  workEmail: yup.string().label("Work Email").email().lowercase(),
  location: yup.string().label("Location").notRequired(),
  rawLocation: yup.string().label("Raw Location").notRequired(),
  googleLocationId: yup.string().label("Google Location Id").notRequired(),
  timezone: yup.string().label("Timezone").notRequired(),
  pronouns: yup.string().label("Pronouns").notRequired(),
  linkedinUrl: yup.string().label("LinkedIn").notRequired(),
  department: yup.string().label("Department").notRequired(),
  country: yup.string().label("Country").notRequired(),
  phoneCountryCode: yup.string().label("Phone Country Code").notRequired(),
  phoneNumber: yup.string().label("Phone Number").notRequired(),
  employmentType: yup.string().label("Employment Type").notRequired(),
  workMode: yup.string().label("Work Mode").notRequired(),
  startDate: yup.date().label("Start Date"),
  pathIds: yup.array().of(yup.string().required()).optional().label("Paths")
    .required(),
  onboardingPlanUrl: yup.string().label("Onboarding Plan Url").notRequired(),
});
